var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.594,
    height: 14.544,
    viewBox: "0 0 16.594 14.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-411.259 -764.126)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.533 524.121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.019,3.2a.221.221,0,0,1,0-.179A4.892,4.892,0,0,1,4.444,0,4.892,4.892,0,0,1,8.869,3.021a.221.221,0,0,1,0,.179A4.892,4.892,0,0,1,4.444,6.222,4.892,4.892,0,0,1,.019,3.2Z",
    transform: "translate(434.096 246.532)",
    fill: "none",
    stroke: "#0c4767",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.333,2.666A1.333,1.333,0,1,1,2.666,1.333,1.333,1.333,0,0,1,1.333,2.666Z",
    transform: "translate(437.207 248.31)",
    fill: "none",
    stroke: "#fd9926",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.459 573.726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.968,204.04h-6.811a.454.454,0,0,1-.452-.452V191.757a.454.454,0,0,1,.452-.452h9.778a.454.454,0,0,1,.452.452v2.98a.452.452,0,1,0,.9,0v-2.98a1.358,1.358,0,0,0-1.357-1.357h-9.778a1.358,1.358,0,0,0-1.357,1.357v11.831a1.358,1.358,0,0,0,1.357,1.357h6.811a.452.452,0,1,0,0-.9Z",
    transform: "translate(0 0)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.948,362.652a.454.454,0,0,0-.452-.452h-5.343a.452.452,0,1,0,0,.9H294.5A.452.452,0,0,0,294.948,362.652Zm-2.747,2.517a.454.454,0,0,0-.452-.452h-2.6a.452.452,0,1,0,0,.9h2.6A.451.451,0,0,0,292.2,365.169Zm-3.048,2.065a.452.452,0,1,0,0,.9h1.4a.452.452,0,0,0,0-.9Z",
    transform: "translate(-102.528 -167.915)",
    fill: "#f18904"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEvent);
export default __webpack_public_path__ + "static/media/view-event.dbad0429484f8521928339cf20e7223f.svg";
export { ForwardRef as ReactComponent };